<template lang="pug">
.Lever(@click="pageDown")
</template>
<script>
import { scroll, $el, onScroll } from 'services/scroll';
import { bindScrollSlideVert } from 'utils';

export default {
  name: 'Lever',

  methods: {
    pageDown () {
      // scroll($el.scrollTop + window.innerHeight);
      this.scrollSlide(1);

      this.$el.style.transform = 'translateY(20px)';
      setTimeout(() => {
        this.$el.style.transform = '';
      }, 400);
    },

    onScroll (delta, { scrollTop, offsetHeight, scrollHeight }) {
      const hide = scrollHeight - offsetHeight < scrollTop + window.innerHeight / 2;
      this.$el.classList.toggle('--hide', hide);
    },
  },

  mounted () {
    this.scrollSlide = bindScrollSlideVert($el);
    this.offScroll = onScroll(this.onScroll);
  },

  unmounted () {
    this.offScroll();
  },
};

</script>
<style>
.Lever {
  --size: 35px;
  --c: var(--white);

  position: relative;

  width: var(--size);
  height: var(--size);

  border-radius: var(--size);
  box-shadow: 0 0 0 1px var(--c);
  transform: translateY(0px);
  cursor: pointer;
  opacity: .6;

  transition: transform .3s;

  &.--hide {
    transform: translateY(100px);
  }

  &:hover {
    opacity: 1;

    transform: translateY(-10px);
  }

  &:after {
    position: relative;
    top: 11px;
    left: 13px;

    --s: 8px;
    display: block;
    width: var(--s);
    height: var(--s);

    border: 1px solid var(--c);
    border-width: 0 1px 1px 0;

    transform: rotate(45deg);

    content: '';
  }
}

</style>
